<template>
  <draggable-item-placeholder
    :show-icon="showIcon"
    :interactable="interactable"
    :style="{ width: itemWidth }"
    @click="onClick"
    class="fleet-item-placeholder relative"
    ><template v-slot:default><div class="slot-empty"></div></template
    ><template v-slot:addicon
      ><div class="addicon-container">
        <icon-add class="addicon"></icon-add></div></template
  ></draggable-item-placeholder>
</template>

<script>
import DraggableItemPlaceholder from "@/components/draggable/DraggableItemPlaceholder";
import IconAdd from "@/components/icons/icon-add";
export default {
  name: "FleetItemPlaceholder",
  props: {
    /**
     * @var Whether to show the plus icon or empty circle
     */
    showIcon: {
      type: Boolean,
      default: true
    },
    /**
     * @var Whether this placeholder can be interacted with. If interactable, this placeholder shows a plus sign.
     * When interacted with, this placeholder emits a @click event.
     */
    interactable: {
      type: Boolean,
      default: false
    },
    itemWidth: {
      type: String,
      default: "10rem"
    }
  },
  components: { IconAdd, DraggableItemPlaceholder },
  methods: {
    onClick(event) {
      this.$emit("click", event);
    }
  }
};
</script>

<style scoped>
.slot-empty {
  position: relative;
  box-sizing: border-box;
  height: 3rem;
  border-radius: 0.35rem;
}
#app.mouse .fleet-item-placeholder:hover {
  cursor: pointer;
}
#app.mouse .fleet-item-placeholder:hover .addicon-container {
  background-color: var(--color-button-hover);
}
.fleet-item-placeholder:active .addicon-container {
  background-color: var(--color-button-active);
}
.addicon-container {
  position: absolute;
  top: 0.1rem;
  left: 0.1rem;
  width: 2.8rem;
  height: 2.8rem;
  border: none;
  background-color: var(--color-button-normal);
  border-radius: 0.3rem;
}
.addicon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: var(--color-text-reg);
}
</style>
